import React, { useEffect, useState } from 'react';
import { useParamsContext } from '../../../contexts/ParamsContext';
import { useAppContext } from '../../../contexts/AppContext';
import { ConfirmDialog } from '../../../components/ConfirmDialog';
import { SettingsRow, SettingsSection } from '../../configuracoes/estabelecimento/Form/SettingsGroup';
import { useGruposClientesContext } from '../Context';
import GruposClientesService from '../Service';

export default function GruposClientesForm() {
    const [loading, setLoading] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const { clear, id } = useParamsContext();
    const { reloadData, data } = useGruposClientesContext();
    const { successSnackbar, errorSnackbar } = useAppContext();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const doc = data?.find((e) => e._id === id);
    const docId = doc?._id;

    // Preenche ao abrir: recarregar a lista nao pode apagar o que foi digitado.
    useEffect(() => {
        if (!docId) return;
        setName(doc.name || '');
        setDescription(doc.description || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docId]);

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        try {
            setLoading(true);
            if (id) {
                await GruposClientesService.update(id, { name: name.trim(), description });
                successSnackbar('Grupo de clientes editado com sucesso!');
            } else {
                await GruposClientesService.create({ name: name.trim(), description });
                successSnackbar('Grupo de clientes criado com sucesso!');
            }

            await reloadData();
            clear();
        } catch (e) {
            console.log(e);
            errorSnackbar('Ocorreu um erro ao salvar o grupo de clientes.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setDeleting(true);
            await GruposClientesService.delete(id);
            await reloadData();
            successSnackbar('Grupo de clientes removido.');
            clear();
        } catch (e) {
            errorSnackbar('Ocorreu um erro ao remover o grupo de clientes.');
            setDeleting(false);
            setOpenDelete(false);
        }
    };

    return (
        <form onSubmit={submit} className="estab-settings sf-page mx-auto max-w-2xl space-y-6 px-2">
            <SettingsSection>
                <SettingsRow label="Nome" htmlFor="grupo-nome">
                    <input
                        id="grupo-nome"
                        type="text"
                        className="input estab-field"
                        placeholder="Nome do grupo"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </SettingsRow>
                <SettingsRow label="Descrição" htmlFor="grupo-descricao" stacked>
                    <textarea
                        id="grupo-descricao"
                        className="textarea estab-field !ml-0 !min-h-[5.5rem] !w-full"
                        placeholder="Para que serve este grupo"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                </SettingsRow>
            </SettingsSection>

            {!!id && (
                <div className="sf-group">
                    <button type="button" className="sf-destructive-row" onClick={() => setOpenDelete(true)}>
                        Remover grupo
                    </button>
                </div>
            )}

            <div className="estab-savebar gap-2">
                <button
                    type="button"
                    className="btn btn-ghost flex-1 sm:flex-none sm:min-w-[8rem]"
                    onClick={clear}
                    disabled={loading}
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="btn btn-primary flex-1 sm:flex-none sm:min-w-[11rem]"
                    disabled={loading}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    {id ? 'Salvar alterações' : 'Criar grupo'}
                </button>
            </div>

            {openDelete && (
                <ConfirmDialog
                    title="Remover grupo?"
                    confirmLabel="Remover"
                    loading={deleting}
                    onConfirm={handleDelete}
                    onClose={() => setOpenDelete(false)}
                >
                    O grupo sai da lista. Os clientes dele não são removidos.
                </ConfirmDialog>
            )}
        </form>
    );
}
